import {createAsyncThunk} from '@reduxjs/toolkit';
import api from 'services/axios';

export const loginByUserAndPass = createAsyncThunk<any, any>(
  'loginByUserPass',
  async ({username, password}: any) => {
    try {
      const form = new FormData();
      form.append('username', username);
      form.append('password', password);
      const response = await api.post('user/login', form);
      return response.data.meta;
    } catch (e: any) {
      console.warn(e);
    }
  }
);

export const loginUserByOtp = createAsyncThunk<any, any>(
  'loginUserByOtp',
  async ({cellphone, code}, thunkApi) => {
    try {
      const response = await api.post(`auth/dakhl/login`, {cellphone, code}, {baseUrl: true});

      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getCaptcha = createAsyncThunk<any, void>('getCaptcha', async (_params, thunkApi) => {
  try {
    const res = await api.get(`captcha/check/type`, {
      goBaseUrl: true
    });

    return thunkApi.fulfillWithValue(res.data);
  } catch (e: any) {
    return thunkApi.rejectWithValue(e);
  }
});

export const sendOtp = createAsyncThunk<any, any>('sendOtp', async (data, thunkApi) => {
  try {
    const res = await api.post(`auth/dakhl/init`, {cellphone: data}, {baseUrl: true});
    return thunkApi.fulfillWithValue(res);
  } catch (e: any) {
    return thunkApi.rejectWithValue(e);
  }
});
